var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '@emotion/styled';
var StyledSplashLayer = styled.section(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 1920px;\n  height: 1080px;\n  position: absolute;\n  background: black;\n  top: 0;\n  left: 0;\n  z-index: 999999;\n\n  .spinner {\n    margin-top: 150px;\n  }\n"], ["\n  width: 1920px;\n  height: 1080px;\n  position: absolute;\n  background: black;\n  top: 0;\n  left: 0;\n  z-index: 999999;\n\n  .spinner {\n    margin-top: 150px;\n  }\n"])));
export default StyledSplashLayer;
var templateObject_1;
